import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "./Features/api/apiSlice";
import aiChatReducer from "./Features/states/ai-agent/aiChatSlice";
import analyticsReducer from "./Features/states/analytics/analyticsSlice";
import authReducer from "./Features/states/auth-management/authSlice";
import beosReducer from "./Features/states/beos/beosSlice";
import bookingsReducer from "./Features/states/bookings/bookingsSlice";
import calendarReducer from "./Features/states/calendar/calendarSlice";
import customersReducer from "./Features/states/customers/customersSlice";
import dashboardReducer from "./Features/states/dashboard/dashboardSlice";
import financeReducer from "./Features/states/finance/financeSlice";
import helpReducer from "./Features/states/help/helpSlice";
import leadPipelineReducer from "./Features/states/lead-pipeline/leadPipelineSlice";
import menuPackagesReducer from "./Features/states/menu-packages/menuPackagesSlice";
import accountSettingsReducer from "./Features/states/settings/accountSettingsSlice";
import bookingSettingsReducer from "./Features/states/settings/bookingSettingsSlice";
import cancellationSettingsReducer from "./Features/states/settings/cancellationSettingsSlice";
import companySettingsReducer from "./Features/states/settings/companySettingsSlice";
import configurationSettingsReducer from "./Features/states/settings/configurationSettingsSlice";
import customerSettingsReducer from "./Features/states/settings/customerSettingsSlice";
import notificationSettingsReducer from "./Features/states/settings/notificationSettingsSlice";
import paymentSettingsReducer from "./Features/states/settings/paymentSettingsSlice";
import permissionsReducer from "./Features/states/settings/permissionsSlice";
import pricingSessionsReducer from "./Features/states/settings/pricingSessionsSlice";
import spacePricingReducer from "./Features/states/settings/spacePricingSlice";
import venuePricingReducer from "./Features/states/settings/venuePricingSlice";
import venuesReducer from "./Features/states/venues/venuesSlice";

export const store = configureStore({
  reducer: {
    aiChat: aiChatReducer,
    analytics: analyticsReducer,
    auth: authReducer,
    beos: beosReducer,
    bookings: bookingsReducer,
    calendar: calendarReducer,
    customers: customersReducer,
    dashboard: dashboardReducer,
    finance: financeReducer,
    leadPipeline: leadPipelineReducer,
    help: helpReducer,
    menuPackages: menuPackagesReducer,
    companySettings: companySettingsReducer,
    configurationSettings: configurationSettingsReducer,
    accountSettings: accountSettingsReducer,
    bookingSettings: bookingSettingsReducer,
    cancellationSettings: cancellationSettingsReducer,
    customerSettings: customerSettingsReducer,
    notificationSettings: notificationSettingsReducer,
    paymentSettings: paymentSettingsReducer,
    permissions: permissionsReducer,
    venuePricing: venuePricingReducer,
    pricingSessions: pricingSessionsReducer,
    spacePricing: spacePricingReducer,
    venues: venuesReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
